export const LINK = 'PAYMENT_LINK';
export const BUTTON = 'PAYMENT_BUTTON';



// WEBPACK FOOTER //
// ./src/shared/enums/paymentStrategy.js